import "../controllers/index"
import "../initializers/turbo_custom_actions"
import "../initializers/third_party_widgets_cleanup"

import "@hotwired/turbo-rails"
Turbo.session.drive = false

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)
